import React, { useEffect, useState } from 'react';
import { Grid, Box, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { AntSwitch } from 'common/AntSwitch';

import { styles } from "./styles";


interface SwitchGroupProps {
  roleData: any,
  switchChange: Function,
  pageChange: Function,
  parentChecked: boolean,
  isEdit?: boolean
}

const SwitchGroup: React.FC<SwitchGroupProps> = ({ roleData, switchChange, parentChecked, pageChange, isEdit }) => {
  const [checked, setChecked] = useState(false);
  const [filtered, setFiltered] = useState<any>([]);
  const [deletePermission, setDeletePermission] = useState(true);
  const [editPermission, setEditPermission] = useState(false);
  const [addPermission, setAddPermission] = useState(false);

  useEffect(() => {
    setChecked(false);
    if(!isEdit) {
      console.log(roleData.canAdd,roleData.canEdit);
      setEditPermission(checked);
      // setDeletePermission(checked);
      setAddPermission(checked);
    }
  }, []);//checked

  useEffect(() => {
    console.log(roleData)
    setChecked(false);
    setEditPermission(false);
    setChecked(false);
    if(roleData){
      if(roleData.canEdit){
        setEditPermission(true);
      }
      if(roleData.canChecked){
        setChecked(true);
      }
    }
    if(isEdit) {
      setAddPermission(roleData.canAdd);
      setEditPermission(roleData.canEdit);
      // setDeletePermission(roleData.canDelete);
      if(!roleData.canAdd && !roleData.canEdit  ) {
        setChecked(false);
      } else {
        setChecked(true);
      }
    }

  }, [isEdit, roleData]);

  const handleSingleSwitch = (type: string, value: boolean) => {
    if(type === "add") {
      setAddPermission(value);
      switchChange(roleData.masterPermissionId, { canAdd: value });
    }
    if(type === "edit") {
      setEditPermission(value);
      switchChange(roleData.masterPermissionId, { canEdit: value });
    }
    if(value === true && checked === false) {
      setChecked(true);
    }
  };

  const handlePageChange = (value: boolean) => {
    setChecked(value);
    pageChange(roleData.masterPermissionId, value);
  };

  return (
    <Box sx={styles.screenContainer}>
      <Grid item xs={7} sx={styles.screenContainer}>
        <Checkbox size="small" checked={checked} onChange={(e: any) => handlePageChange(e.target.checked)} />
        <Typography sx={styles.screenText} style={{width:"500px"}}>{roleData.screenName}</Typography>
      </Grid>
      <Grid item xs={5} sx={styles.screenContainer}>
        {roleData.editPermission &&
            <Box sx={styles.screenContainer}>
              <FormControlLabel
                  label=""
                  control={<AntSwitch checked={editPermission} onChange={(e: any) => handleSingleSwitch("edit", e.target.checked)}/>}
                  sx={{marginRight: ".5rem"}}
              />
              <Typography sx={styles.screenText}>Edit</Typography>
            </Box>
        }
      </Grid>
    </Box>
  )
}

export default SwitchGroup;
